import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    const scrollable = getScrollableParent(document.getElementById('root'))

    if (scrollable) {
      scrollable.scrollTo({ top: 0, behavior: 'instant' })
    }

    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function getScrollableParent(el) {
  while (el && el !== document.body) {
    const style = window.getComputedStyle(el)
    const overflowY = style.overflowY
    if (overflowY === 'auto' || overflowY === 'scroll') return el
    el = el.parentElement
  }
  return document.documentElement
}
